module.exports = __webpack_public_path__ + "static/media/img196.8ad32809.jpg";